export const HandledServerErrorsStatuses = [500];
